import { useCallback } from 'react';

import {
  Button,
  ButtonProps,
} from '@bambi/component-library/src/components/Button';

import { useFeature } from 'src/app/FeatureToggle';
import { useAppDispatch } from 'src/app/store/hooks';

import { setShowAssignmentTransferModal } from '../assignmentManagement.slice';

export function TransferAssignmentAction(props: Partial<ButtonProps>) {
  const dispatch = useAppDispatch();
  const handleClick = useCallback(() => {
    dispatch(setShowAssignmentTransferModal(true));
  }, [dispatch]);
  const { isEnabled, isLoading } = useFeature('transfer assignment');

  if (isLoading || !isEnabled) {
    return null;
  }

  return (
    <Button {...props} variant="secondary-outline" onClick={handleClick}>
      Transfer Crew Schedule
    </Button>
  );
}
